'use strict';

exports.__esModule = true;
exports.default = getDisplayName;
function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/getDisplayName.js
 ** module id = 451
 ** module chunks = 0
 **/